module.exports = __webpack_public_path__ + "static/media/mobile-close-icon.0716619e.svg";